// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__ugqgd g-grid-container g-grid","text":"style_text__nzmW4","articleList":"style_articleList__pAR84","cta":"style_cta__yHBB4"};